// import ReactGA from "react-ga";
import { StylesProvider } from "@material-ui/core/styles";
import { BrowserRouter } from "react-router-dom";

import { IntercomProvider } from "react-use-intercom";

import "./App.scss";

import Routes from "./Routes";
import BookingProvider from "./providers/BookingProvider";

function App() {
  return (
    <IntercomProvider appId={"t2482zw8"}>
      <BrowserRouter>
        <StylesProvider injectFirst>
          <BookingProvider>
            <Routes />
          </BookingProvider>
        </StylesProvider>
      </BrowserRouter>
    </IntercomProvider>
  );
}

export default App;
